import React from "react";
import Seo from "../components/Seo";

export default function Shipping() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <Seo title="Shipping & Local Pickup" description="Shipping rates, timelines, and local pickup info for Rooted in Amador seed orders." path="/shipping" />
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">Orders</div>
      <h1 className="font-display text-5xl text-darkRoast mb-12">Shipping & Pickup</h1>
      <div className="text-earth space-y-8 leading-relaxed">

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Shipping</h2>
          <p>We ship all orders via USPS First Class Mail from Plymouth, California.</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li className="flex justify-between border-b border-darkRoast/10 pb-2">
              <span>Orders under $35</span>
              <span className="font-medium text-darkRoast">$4.50 flat rate</span>
            </li>
            <li className="flex justify-between border-b border-darkRoast/10 pb-2">
              <span>Orders $35 and over</span>
              <span className="font-medium text-darkRoast">Free shipping</span>
            </li>
          </ul>
          <p className="mt-4 text-sm">Most orders ship within 1–3 business days. Delivery typically takes 3–7 days depending on your location. You'll receive an email confirmation when your order is placed.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Local pickup</h2>
          <p>Free local pickup is available in Plymouth, CA. Select "Local Pickup" at checkout and we'll reach out by email to arrange a pickup time that works for you. No waiting, no shipping fees.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Processing time</h2>
          <p>Seeds are hand-packed in small batches. Please allow 1–3 business days for your order to be prepared before it ships or is ready for pickup.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">Questions?</h2>
          <p>Email us at <a href="mailto:hello@rootedinamador.com" className="text-darkRoast underline hover:text-sage">hello@rootedinamador.com</a> and we'll get back to you quickly.</p>
        </section>

      </div>
    </div>
  );
}
